import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  ma_don_hang: undefined, // required, minLength: 1 - Mã đơn hàng
  // required - Thông tin dòng họ
  dong_ho: {
    dong_ho_id: undefined, // required, ref: dong_ho - Mã dòng họ
    ten: undefined, // required
  },
  // required - Thông tin người đặt hàng
  nguoi_dat_hang: {
    nguoi_dung_id: undefined, // required, ref: nguoi_dung - Mã người đặt hàng
    xung_ho: undefined, // optional - Xưng hô
    ten: undefined, // required - Tên người đặt hàng
  },
  loai: undefined, // required, enum(khoi_tao, gia_han) - Loại đơn hàng
  // optional - Thông tin gói dịch vụ
  goi_dich_vu: {
    goi_id: undefined, // required, ref: goi_dich_vu - Mã gói dịch vụ
    ten_goi: undefined, // required - Tên gói
    don_gia: undefined, // required, min: 0 - Đơn giá niêm yết cho một chu kỳ.
    so_luong_chu_ky: undefined, // required, min: 1 - Số lượng chu kỳ. Ví dụ: đăng ký 2 năm thì so_luong_chu_ky=2, ten_chu_ky=năm
    ten_chu_ky: undefined, // required - Tên chu kỳ. Ví dụ: đăng ký 2 năm thì so_luong_chu_ky=2, ten_chu_ky=năm
  },
  vas: [
    // required - Danh sách các dịch vụ gia tăng kèm theo
    {
      vas_id: undefined, // required, ref: vas - Mã dịch vụ vas
      ten: undefined, // required - Tên dịch vụ vas
      don_gia: undefined, // required, min: 0 - Đơn giá niêm yết cho số lượng = 1 và so_luong_chu_ky = 1
      so_luong: undefined, // required, min: 1 - Số lượng. Ví dụ: 3 gói 100GB trong 2 năm thì số lượng là 3
      don_vi: undefined, // optional - Đơn vị của VAS. Ví dụ: 3 gói 100GB trong 2 năm thì đơn vị là 100GB
      so_luong_chu_ky: undefined, // optional, min: 1 - Số lượng chu kỳ. Ví dụ: 3 gói 100GB trong 2 năm thì số lượng chu kỳ là 2
      ten_chu_ky: undefined, // optional - Tên chu kỳ. Ví dụ: 3 gói 100GB trong 2 năm thì tên chu kỳ là năm
    },
  ],
  // optional - Thông tin khuyến mại
  khuyen_mai: {
    ma_giam_gia: undefined, // optional - Mã giảm giá
    noi_dung: undefined, // optional - Nội dung giảm giá
  },
  // required - Tổng giá
  gia: {
    niem_yet: undefined, // required, min: 0 - Tổng giá niêm yết. =goi_dich_vu.don_gia*goi_dich_vu.so_luong_chu_ky + sigma(vas.don_gia*vas.so_luong*vas.so_luong_chu_ky)
    giam_gia: undefined, // required, min: 0 - Tổng khuyến mại giảm giá
    thanh_tien: undefined, // required, min: 0 - Tổng tiền đơn hàng. =gia.niem_yet - gia.giam_gia
  },
  trang_thai: undefined, // required, enum(cho_thanh_toan, da_thanh_toan, huy, dang_san_xuat, dang_giao_hang, da_giao_hang, hoan_tra) - Trạng thái đơn hàng
  thoi_diem_tao: undefined, // required - Thời điểm tạo đơn
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.loaiDonHang = [
  {
    value: "khoi_tao",
    label: "Khởi tạo",
  },
  {
    value: "gia_han",
    label: "Gia hạn",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      ma_don_hang: '',
      tinh_id: '',
      dai_ly_id: '',
      'dong_ho.ten_dong_ho': '',
      'danh_sach_san_pham.san_pham_id': '',
      trang_thai: '',
      thoi_diem_tao_tu: '',
      thoi_diem_tao_den: ''
    },
    operator: {
      ma_don_hang: ':regex_i:',
      tinh_id: '',
      dai_ly_id: '',
      'dong_ho.ten_dong_ho': ':regex_i:',
      'danh_sach_san_pham.san_pham_id': '',
      trang_thai: '',
      thoi_diem_tao_tu: 'fromTime',
      thoi_diem_tao_den: 'toTime'
    }
  }
};

export default model;
